<template>
  <div id="app">
    <router-view />
    <widget-otp />
  </div>
</template>

<script>
import TitleMixins from "@/mixins/TitleMixins";

export default {
  mixins: [TitleMixins],
}
</script>
